// Article action types
export const FETCH_ARTICLES_REQUEST = 'FETCH_ARTICLES_REQUEST';
export const FETCH_ARTICLES_SUCCESS = 'FETCH_ARTICLES_SUCCESS';
export const FETCH_ARTICLES_FAILURE = 'FETCH_ARTICLES_FAILURE';

export const FETCH_ARTICLE_BY_SLUG_REQUEST = 'FETCH_ARTICLE_BY_SLUG_REQUEST';
export const FETCH_ARTICLE_BY_SLUG_SUCCESS = 'FETCH_ARTICLE_BY_SLUG_SUCCESS';
export const FETCH_ARTICLE_BY_SLUG_FAILURE = 'FETCH_ARTICLE_BY_SLUG_FAILURE';

export const FETCH_TOP_ARTICLES_REQUEST = 'FETCH_TOP_ARTICLES_REQUEST';
export const FETCH_TOP_ARTICLES_SUCCESS = 'FETCH_TOP_ARTICLES_SUCCESS';
export const FETCH_TOP_ARTICLES_FAILURE = 'FETCH_TOP_ARTICLES_FAILURE';

export const FETCH_POPULAR_ARTICLES_REQUEST = 'FETCH_POPULAR_ARTICLES_REQUEST';
export const FETCH_POPULAR_ARTICLES_SUCCESS = 'FETCH_POPULAR_ARTICLES_SUCCESS';
export const FETCH_POPULAR_ARTICLES_FAILURE = 'FETCH_POPULAR_ARTICLES_FAILURE';

export const FETCH_TRENDING_ARTICLES_REQUEST = 'FETCH_TRENDING_ARTICLES_REQUEST';
export const FETCH_TRENDING_ARTICLES_SUCCESS = 'FETCH_TRENDING_ARTICLES_SUCCESS';
export const FETCH_TRENDING_ARTICLES_FAILURE = 'FETCH_TRENDING_ARTICLES_FAILURE';

export const FETCH_SIMILAR_ARTICLES_REQUEST = 'FETCH_SIMILAR_ARTICLES_REQUEST';
export const FETCH_SIMILAR_ARTICLES_SUCCESS = 'FETCH_SIMILAR_ARTICLES_SUCCESS';
export const FETCH_SIMILAR_ARTICLES_FAILURE = 'FETCH_SIMILAR_ARTICLES_FAILURE';

export const FETCH_FEATURED_ARTICLE_REQUEST = 'FETCH_FEATURED_ARTICLE_REQUEST';
export const FETCH_FEATURED_ARTICLE_SUCCESS = 'FETCH_FEATURED_ARTICLE_SUCCESS';
export const FETCH_FEATURED_ARTICLE_FAILURE = 'FETCH_FEATURED_ARTICLE_FAILURE';

export const CREATE_ARTICLE_REQUEST = 'CREATE_ARTICLE_REQUEST';
export const CREATE_ARTICLE_SUCCESS = 'CREATE_ARTICLE_SUCCESS';
export const CREATE_ARTICLE_FAILURE = 'CREATE_ARTICLE_FAILURE';

export const UPDATE_ARTICLE_REQUEST = 'UPDATE_ARTICLE_REQUEST';
export const UPDATE_ARTICLE_SUCCESS = 'UPDATE_ARTICLE_SUCCESS';
export const UPDATE_ARTICLE_FAILURE = 'UPDATE_ARTICLE_FAILURE';

export const DELETE_ARTICLE_REQUEST = 'DELETE_ARTICLE_REQUEST';
export const DELETE_ARTICLE_SUCCESS = 'DELETE_ARTICLE_SUCCESS';
export const DELETE_ARTICLE_FAILURE = 'DELETE_ARTICLE_FAILURE';


